<template>
  <div class="document-viewer">
    <iframe
      v-if="embedUrl"
      :key="reloadToken + ':' + viewerMode"
      :src="embedUrl"
      width="100%"
      height="100%"
      frameborder="0"
      allowfullscreen
      @load="onIframeLoad"
    />
    <div v-else class="document-viewer__empty">{{ $t("common.noFile") }}</div>
    <div class="document-viewer__toolbar">
      <span v-if="loading" class="document-viewer__hint">
        {{ $t("docViewer.loading") }}
      </span>
      <span v-else class="document-viewer__hint">
        {{ $t("docViewer.trouble") }}
      </span>
      <button
        v-if="canUseOffice"
        type="button"
        class="document-viewer__action"
        @click="switchToOffice"
        :disabled="viewerMode === 'office'"
      >
        {{ $t("docViewer.office") }}
      </button>
      <button type="button" class="document-viewer__action" @click="reload">
        {{ $t("docViewer.reload") }}
      </button>
      <a
        v-if="fileUrl"
        class="document-viewer__action"
        :href="fileUrl"
        target="_blank"
        rel="noopener noreferrer"
      >
        {{ $t("chat.openNewTab") }}
      </a>
    </div>
  </div>
</template>

<script>
import buildDocumentEmbedUrl, {
  getFileExtension,
} from "@/shared/buildDocumentEmbedUrl";

const OFFICE_EXTENSIONS = ["ppt", "pptx", "doc", "docx", "xls", "xlsx"];

export default {
  name: "DocumentViewerIframe",
  props: {
    fileUrl: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      viewerMode: "auto",
      loading: true,
      reloadToken: 0,
    };
  },
  computed: {
    embedUrl() {
      return buildDocumentEmbedUrl(this.fileUrl, this.viewerMode);
    },
    canUseOffice() {
      return OFFICE_EXTENSIONS.includes(getFileExtension(this.fileUrl));
    },
  },
  watch: {
    fileUrl() {
      this.viewerMode = "auto";
      this.loading = true;
      this.reloadToken += 1;
    },
  },
  methods: {
    onIframeLoad() {
      this.loading = false;
    },
    switchToOffice() {
      this.viewerMode = "office";
      this.loading = true;
      this.reloadToken += 1;
    },
    reload() {
      this.loading = true;
      this.reloadToken += 1;
    },
  },
};
</script>

<style scoped>
.document-viewer {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

/* `min-height: 60vh` + a barra de ações estouravam o palco de altura fixa do
   visualizador de materiais (card 86aknb8n7). O único uso deste componente é
   dentro daquele palco, que já define a altura, então `flex: 1` basta. */
.document-viewer iframe {
  flex: 1;
  min-height: 0;
  border: 1px solid rgba(15, 61, 62, 0.12);
  border-radius: 12px;
}

.document-viewer__empty {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--dk-muted, #6b7280);
}

.document-viewer__toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  margin-top: 8px;
  font-size: 0.85rem;
}

.document-viewer__hint {
  color: var(--dk-muted, #6b7280);
}

.document-viewer__action {
  background: transparent;
  border: 1px solid rgba(15, 61, 62, 0.4);
  border-radius: 8px;
  padding: 4px 10px;
  color: #0f3d3e;
  cursor: pointer;
  font-size: 0.85rem;
  text-decoration: none;
}

.document-viewer__action:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.document-viewer__action:hover:not(:disabled) {
  background: rgba(15, 61, 62, 0.08);
}
</style>
